var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("form", { attrs: { id: "benefitForm" } }, [
            _c(
              "div",
              {},
              [
                _c(
                  "draggable",
                  {
                    staticClass: "drag-view",
                    on: {
                      change: function($event) {
                        return _vm.changePosition()
                      }
                    },
                    model: {
                      value: _vm.surveyList,
                      callback: function($$v) {
                        _vm.surveyList = $$v
                      },
                      expression: "surveyList"
                    }
                  },
                  [
                    _vm._l(_vm.surveyList, function(text, index) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-20"
                          },
                          [
                            _c("div", { staticClass: "card" }, [
                              _c("div", { staticClass: "card-body" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-lg-12 col-md-12 col-sm-12 col-xs-12"
                                  },
                                  [
                                    _c(
                                      "h2",
                                      {
                                        staticClass:
                                          "text-muted display-4 text-danger"
                                      },
                                      [
                                        _c("strong", [
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [_vm._v(_vm._s(text.title))]
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-lg-6 col-md-6 col-sm-12 col-xs-12"
                                  },
                                  [
                                    _c("div", { staticClass: "form-group" }, [
                                      _c("img", {
                                        staticClass: "img-thumbnail",
                                        attrs: { src: text.image_path }
                                      })
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "form-group" }, [
                                      _c("p", {
                                        domProps: {
                                          innerHTML: _vm._s(text.description)
                                        }
                                      })
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-lg-6 col-md-6 col-sm-12 col-xs-12"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "form-group mt-15" },
                                      [
                                        _vm._l(text.button_array, function(
                                          btn,
                                          index
                                        ) {
                                          return [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "mt-1 btn btn-primary",
                                                attrs: {
                                                  href: btn.button_url,
                                                  target: "_blank"
                                                }
                                              },
                                              [_vm._v(_vm._s(btn.button_title))]
                                            ),
                                            _c("br")
                                          ]
                                        })
                                      ],
                                      2
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "col-md-12 col-sm-12 col-xs-12"
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-danger pull-right",
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.deletePoliciesFormsSection(
                                              text.id
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-trash",
                                          attrs: { "aria-hidden": "true" }
                                        })
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" })
                              ])
                            ])
                          ]
                        )
                      ]
                    })
                  ],
                  2
                )
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header-top-container" }, [
      _c("div", { staticClass: "page-name" }, [_vm._v("Draggable Survey List")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b8232ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b8232ea","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/surveys/BlockListViewSurveys.vue
// module id = null
// module chunks = 